import type { ReactElement } from 'react';
import { useRouteError } from 'react-router';

import { RouteError } from './RouteStatus';

export function RouterErrorPage(): ReactElement {
  const error = useRouteError();

  return (
    <RouteError
      error={error}
      reset={() => window.location.reload()}
      fullPage
      overviewHref="/"
    />
  );
}
